<template>
  <v-card>
    <v-card-text class="text-xs-center headline primary--text">
      Mostrando detalhes da fatura
      <div
        class="subheading grey--text text--darken-2"
        v-if="fatura"
      >Dia {{fatura.data_fatura.split('-').reverse().join('/')}}</div>
    </v-card-text>
    <v-card-text class="pa-5 text-xs-center" v-if="loading">
      <v-progress-circular indeterminate size="150" color="primary"></v-progress-circular>
    </v-card-text>
    <v-card-text v-else>
      <v-list>
        <template v-for="(tipo_faturamento, index) in detalhes.tipos_faturamento">
          <v-divider :key="`divider-${index}`" v-if="index > 0"></v-divider>
          <v-list-tile avatar :key="index">
            <v-list-tile-avatar>
              <v-tooltip v-if="tipo_faturamento.combustivel" bottom>
                  <svg-filler
                    :path="combustiveisJson[tipo_faturamento.combustivel].icone ? require(`@/assets/combs/${combustiveisJson[tipo_faturamento.combustivel].icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                    width="50px"
                    height="50px"
                    :fill="combustiveisJson[tipo_faturamento.combustivel].color"
                    slot="activator"
                  />
                  {{combustiveisJson[tipo_faturamento.combustivel].nome}}
              </v-tooltip>
              <v-icon color="green" v-else>attach_money</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-text="`Valor: R$ ${tipo_faturamento.valor}`"
                class="font-weight-light"
              ></v-list-tile-title>
              <v-list-tile-sub-title v-text="tipo_faturamento.descricao"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-text>
    <v-footer
    dark
      height="auto"
    >
      <v-card
        class="flex"
        flat
        tile
      >
        <v-card-actions class="primary darken-3 justify-center">
          <strong>Banco do Brasil</strong>&nbsp;- Ag.<strong>1668-3</strong>, C.C. <strong>56373-0</strong>
        </v-card-actions>
      </v-card>
    </v-footer>
  </v-card>
</template>

<script>
export default {
  props: ['fatura'],
  data () {
    return {
      detalhes: {}
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    combustiveisJson () {
      let json = {}
      this.combustiveis.forEach(comb => {
        json[comb.id_combustivel] = { ...comb }
      })
      return json
    }
  },
  watch: {
    fatura (val) {
      if (val) {
        this.carregarDetalhes()
      }
    }
  },
  mounted () {
    if (this.fatura) {
      this.carregarDetalhes()
    }
  },
  methods: {
    carregarDetalhes () {
      this.$store.dispatch('detalhesFatura', this.fatura.id).then(json => {
        this.detalhes = json
      })
    }
  }
}
</script>
